<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <div class="row">
            <h3
              class="ml-md-3 ml-1 mb-md-0"
              :class="type === 'dark' ? 'text-white' : ''"
            >
              {{ title }}
            </h3>
            <base-button
              type="primary"
              size="sm"
              class="ml-1"
              @click="showFilterModal = true"
              >ขั้นสูง</base-button
            >
            <!-- <div class="row ml-md-1 ml-1">
              <select
                v-model="selectedAgent"
                @change="onSelectAgent($event)"
                class="ml-md-2"
              >
                <option value="">ทั้งหมด</option>
                <option
                  v-for="agent in masterAgent"
                  :key="agent.id"
                  :value="agent.id"
                  >{{ agent.name }}</option
                >
              </select>
              <select
                v-model="selectedMonth"
                @change="onSelectMonth($event)"
                class="ml-md-2 mr-2 mt-2 mt-md-0"
              >
                <option value="" disabled selected>เดือน</option>
                <option
                  v-for="month in masterMonth"
                  :key="month.id"
                  :value="month.id"
                  >{{ month.name }}</option
                >
              </select>
              <select
                v-model="selectedYear"
                @change="onSelectYear($event)"
                class="mt-2 mt-md-0"
              >
                <option value="" disabled selected>ปี</option>
                <option v-for="year in masterYear" :key="year" :value="year">{{
                  year
                }}</option>
              </select>
              <base-button
                type="primary"
                size="sm"
                class="ml-md-2 mt-md-0 mt-2"
                :class="lvl != 999 ? 'none' : ''"
                @click="onExport"
                >Export</base-button
              >
            </div> -->
          </div>
        </div>
        <div class="col-6 text-right">
          <router-link to="/customerInsuranceAddNew">
            <base-button type="primary" size="sm">เพิ่มข้อมูลใหม่</base-button>
          </router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="insurances"
      >
        <template slot="columns">
          <th v-show="isSelecting">#</th>
          <th>ชื่อสกุล</th>
          <th>ประเภท</th>
          <th>วันหมดสัญญา</th>
          <th>เลขทะเบียน</th>
          <th>เบอร์โทร</th>
          <th class="company">บริษัท</th>
          <th>AGENT</th>
          <th>พนักงาน</th>
          <th>เวลาที่คีย์ข้อมูล</th>
          <!-- <th>ทุนประกัน</th>
          <th>เบี้ยประกัน</th> -->
          <!-- <th>ทุนประกัน (ใหม่)</th>
          <th>เบี้ยประกัน (ใหม่)</th> -->
          <th></th>
        </template>

        <template slot-scope="{ row }">
          <th v-show="isSelecting">
            <input
              type="checkbox"
              @click="toggleSelect(row.id)"
              :checked="checkIfSelect(row.id)"
            />
          </th>
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body cutname">
                <span class="name mb-0 text-sm"
                  >{{ row.name_prefix }} {{ row.name }}</span
                >
              </div>
            </div>
          </th>
          <td>
            {{ row.get_type ? row.get_type.name : "" }}
          </td>
          <td class="tel">
            <strong>
              {{ row.cover_end_date ? formatDate(row.cover_end_date) : "" }}
            </strong>
          </td>
          <td>
            {{ row.license_plate }}
            <!-- {{
              row.license_plate_province !== -1 ? row.province_plate.name : ""
            }} -->
          </td>
          <!-- <td>
            {{ row.province !== null ? row.province.name : "ไม่มี" }}
          </td> -->
          <td>
            {{ row.tel }}
          </td>
          <td class="company">
            {{ row.company ? row.company.nickname : "" }}
          </td>
          <td>
            {{ row.get_agent ? row.get_agent.name : "" }}
          </td>
          <td>
            {{ row.get_employee ? row.get_employee.name : "" }}
          </td>
          <td>
            {{ formatDateTime(row.created_at) }}
          </td>
          <!-- <td>
            {{ row.coverage ? row.coverage.toLocaleString() : "" }}
            ({{ row.new_coverage ? row.new_coverage.toLocaleString() : "" }})

            <span
              v-if="row.coverage > row.new_coverage"
              class="text-success ml-1"
              ><i class="fa fa-arrow-down"></i
            ></span>

            <span
              v-if="row.coverage < row.new_coverage"
              class="text-danger ml-1"
              ><i class="fa fa-arrow-up"></i
            ></span>
          </td>
          <td>
            {{
              row.insurance_premium
                ? row.insurance_premium.toLocaleString()
                : ""
            }}
            ({{
              row.new_insurance_premium
                ? row.new_insurance_premium.toLocaleString()
                : ""
            }})
            <span
              v-if="row.insurance_premium > row.new_insurance_premium"
              class="text-success ml-1"
              ><i class="fa fa-arrow-down"></i
            ></span>

            <span
              v-if="row.insurance_premium < row.new_insurance_premium"
              class="text-danger ml-1"
              ><i class="fa fa-arrow-up"></i
            ></span>
          </td> -->
          <!-- <td>
            {{ row.new_coverage ? row.new_coverage.toLocaleString() : "" }}
          </td>
          <td>
            {{
              row.new_insurance_premium
                ? row.new_insurance_premium.toLocaleString()
                : ""
            }}
          </td> -->
          <td class="text-right">
            <base-button type="warning" size="sm" @click="goTo(row.id)"
              >แก้ไข</base-button
            >
          </td>
        </template>
      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    ></div>
    <Modal :show="showModal">
      <div class="col text-center">
        <h2>
          ต้องการส่ง SMS ไปยังหมายเลข {{ sms.phoneNumber }} <br />ใช่หรือไม่?
        </h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        ></button>
        <div class="row justify-content-around mt-4">
          <base-button type="info" size="md" @click="sendSMS(sms.id)"
            >ตกลง</base-button
          >
          <base-button type="warning" size="md" @click="showModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
    <Modal :show="showSuccessModal">
      <div class="col text-center">
        <h2>ดำเนินการส่ง SMS ไปยังหมายเลข {{ sms.phoneNumber }} เรียบร้อย</h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        ></button>
        <div class="row justify-content-around mt-4">
          <base-button type="info" size="md" @click="showSuccessModal = false"
            >ปิด</base-button
          >
        </div>
      </div></Modal
    >
    <Modal :show="showAllModal">
      <div class="col text-center">
        <h2>
          ต้องการส่ง SMS ไปยังบุคคลที่เลือกไว้ใช่หรือไม่?
        </h2>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showAllModal = false"
        ></button>
        <div class="row justify-content-around mt-4">
          <base-button type="info" size="md" @click="sendAllSms"
            >ตกลง</base-button
          >
          <base-button type="warning" size="md" @click="showAllModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
    <Modal :show="showEditPremiumModal">
      <div class="col text-center">
        <h2>
          แก้ไขเบี้ยประกันของ <br />
          {{ sms.name }}
        </h2>
        <br />
        <div class="row">
          <div class="col-12 col-md-6">
            <base-input
              alternative=""
              label="ทุนประกัน"
              type="number"
              step="any"
              placeholder="บาท"
              input-classes="form-control-alternative"
              v-model="sms.coverage"
            />
          </div>
          <div class="col-12 col-md-6">
            <base-input
              alternative=""
              label="เบี้ยรวม"
              type="number"
              step="any"
              placeholder="บาท"
              input-classes="form-control-alternative"
              v-model="sms.insurance_premium"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-12">
            <base-input
              alternative=""
              label="Note"
              type="text"
              placeholder="Note"
              input-classes="form-control-alternative"
              v-model="sms.edit_reason"
            />
          </div>
        </div>
        <button
          type="button"
          class="close mt--5"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        ></button>
        <div class="row justify-content-around mt-4">
          <base-button type="info" size="md" @click="onEditPremium(sms.id)"
            >ตกลง</base-button
          >
          <base-button
            type="warning"
            size="md"
            @click="showEditPremiumModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
    <Modal :show="showFilterModal">
      <div class="col justify-content-center text-center">
        <h2>
          ค้นหาขั้นสูง
        </h2>
        <div class="col ml-md-1 ml-1 justify-content-center text-center">
          <div class="row">
            <h4>ตัวแทน:</h4>
            <select
              v-model="selectedAgent"
              @change="onSelectAgent($event)"
              class="ml-2"
            >
              <option value="">ทั้งหมด</option>
              <option
                v-for="agent in masterAgent"
                :key="agent.id"
                :value="agent.id"
                >{{ agent.name }}</option
              >
            </select>
          </div>
          <div class="row mt-2">
            <h4>ตั้งแต่:</h4>
            <datepicker
              :lang="th"
              :format="momentFormat"
              value-type="timestamp"
              class="date-picker ml-2"
              placeholder="คลิกเพื่อเลือกวันหมดอายุ"
              v-model="start"
            ></datepicker>
          </div>
          <div class="row mt-2">
            <h4>ถึง:</h4>
            <datepicker
              :lang="th"
              :format="momentFormat"
              value-type="timestamp"
              class="date-picker ml-2"
              placeholder="คลิกเพื่อเลือกวันหมดอายุ"
              v-model="to"
            ></datepicker>
          </div>
          <div class="row mt-2">
            <h4>จังหวัด:</h4>
            <select
              v-model="selectedProvince"
              @change="onSelectProvince($event)"
              class="ml-2"
            >
              <option value="">ทั้งหมด</option>
              <option
                v-for="province in masterProvince"
                :key="province.id"
                :value="province.id"
                >{{ province.name }}</option
              >
            </select>
          </div>
          <div class="row mt-2">
            <h4>บริษัท:</h4>
            <select
              v-model="selectedCompany"
              @change="onSelectCompany($event)"
              class="ml-2"
            >
              <option value="">ทั้งหมด</option>
              <option
                v-for="company in masterCompany"
                :key="company.id"
                :value="company.id"
                >{{ company.name }}</option
              >
            </select>
          </div>
          <base-button
            type="primary"
            size="sm"
            class="mt-2"
            :class="lvl != 999 ? 'none' : ''"
            @click="onExport"
            >Export</base-button
          >
        </div>
        <div class="row justify-content-around mt-4">
          <base-button
            type="info"
            size="md"
            @click="advanceSearch(''), (showFilterModal = false)"
            >ค้นหา</base-button
          >
          <base-button type="warning" size="md" @click="showFilterModal = false"
            >ยกเลิก</base-button
          >
        </div>
      </div></Modal
    >
  </div>
</template>
<script>
import Modal from "../../components/Modal";
import axios from "axios";
import Datepicker from "vue2-datepicker";
import kickMixin from "../../mixins/kickMixin";
import XLSX from "xlsx";
import moment from "moment";

moment.locale("th");

export default {
  name: "insurance-history-table",
  mixins: [kickMixin],
  components: {
    Modal,
    Datepicker,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
    insurances: {
      type: Array,
      default: function() {
        return [];
      },
    },
    total: {
      type: Number,
    },
    page: {
      type: Number,
    },
  },
  data() {
    return {
      lvl: 0,
      showModal: false,
      showFilterModal: false,
      showSuccessModal: false,
      selectedAgentIdx: "",
      selectedProvinceIdx: "",
      selectedCompanyIdx: "",
      selectedAgent: "",
      selectedProvince: "",
      selectedCompany: "",
      start: "",
      to: "",
      isSelecting: false,
      isSelectAll: false,
      showAllModal: false,
      showAllSuccessModal: false,
      showEditPremiumModal: false,
      selectedRow: [],
      selectedMonth: "",
      selectedYear: "",
      masterProvince: [],
      masterAgent: [],
      masterYear: [
        moment().year() - 5 + 543,
        moment().year() - 4 + 543,
        moment().year() - 3 + 543,
        moment().year() - 2 + 543,
        moment().year() - 1 + 543,
        moment().year() + 543,
        moment().year() + 1 + 543,
        moment().year() + 2 + 543,
        moment().year() + 3 + 543,
        moment().year() + 4 + 543,
        moment().year() + 5 + 543,
      ],
      masterMonth: [],
      masterCompany: [],
      th: {
        formatLocale: {
          firstDayOfWeek: 1,
          monthsShort: [
            "ม.ค.",
            "ก.พ.",
            "มี.ค.",
            "เม.ย.",
            "พ.ค.",
            "มิ.ย.",
            "ก.ค.",
            "ส.ค.",
            "ก.ย.",
            "ต.ค.",
            "พ.ย.",
            "ธ.ค.",
          ],
          weekdaysMin: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        },
        monthBeforeYear: true,
      },
      momentFormat: {
        stringify: (date) => {
          return date
            ? moment(date)
                .add(543, "y")
                .format("D MMM YYYY")
            : null;
        },
        parse: (value) => {
          return value
            ? moment(value, "D MMM YYYY")
                .subtract(543, "y")
                .toDate()
            : null;
        },
      },
      sms: {
        phoneNumber: "",
        id: "",
        name: "",
        insurance_premium: "",
        edit_reason: "",
        coverage: "",
      },
    };
  },
  methods: {
    formatDate(date) {
      let monthNames = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];

      let day = moment(date).date();
      let month = monthNames[moment(date).month()];
      let year = moment(date).year() + 543;

      // let parsedDate = Date.parse(date);
      // let newDate = new Date(parsedDate);
      // let day = newDate.getDate();
      // let month = newDate.getMonth();
      // let year = newDate.getYear();

      // let hour = newDate.getHours();
      // let min = newDate.getMinutes();
      // let sec = newDate.getSeconds();
      // return (
      //   day +
      //   " " +
      //   monthNames[month] +
      //   " " +
      //   (year + 543 + 1900) +
      //   " " +
      //   hour +
      //   ":" +
      //   min +
      //   ":" +
      //   sec
      // );
      return day + " " + month + " " + year;
    },
    formatDateTime(date) {
      let monthNames = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค.",
      ];

      let day = moment(date).date();
      let month = monthNames[moment(date).month()];
      let year = moment(date).year() + 543;
      let hour = moment(date).hour();
      let minute = moment(date).minutes();

      return day + " " + month + " " + year + " เวลา " + hour + ":" + minute;
    },
    notify(id) {
      axios
        .patch("/api/insurance/notify/" + id, null, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            window.location.reload();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    removeNotify(id) {
      if (confirm("ต้องการยกเลิกการเตือนต่ออายุใช่หรือไม่?")) {
        axios
          .patch(
            "/api/insurance/removenotify/" + id,
            null,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then(function(response) {
            if (response.status == 200) {
              window.location.reload();
            }
          })
          .catch(function(error) {
            alert(error);
          });
      }
    },
    sendSMS(id) {
      let localApp = this;
      localApp.showModal = false;
      axios
        .post(
          "/api/sms2",
          {
            id: id,
            tel: localApp.sms.phoneNumber,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            localApp.showSuccessModal = true;
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    showPostCard(id) {
      window.open(
        "/api/insurance/getPostCard/" + id,
        "_blank"
      );
      // axios
      //   .get("/api/insurance/getPostCard/" + id, {
      //     headers: {
      //       Authorization: "Bearer " + localStorage.token,
      //     },
      //     responseType: "blob",
      //   })
      //   .then(function(response) {
      //     const url = window.URL.createObjectURL(new Blob([response.data]));
      //     const link = document.createElement("a");
      //     link.href = url;
      //     link.setAttribute("download", name + ".pdf");
      //     document.body.appendChild(link);
      //     link.click();
      //   })
      //   .catch(function(error) {
      //     alert(error);
      //   });
    },
    getMonths: function() {
      var localApp = this;
      axios
        .get("/api/master/month", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterMonth = response.data.data;

            localApp.selectedMonth = moment().month() + 1;
            localApp.selectedYear = moment().year() + 543;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getAgents: function() {
      var localApp = this;
      axios
        .get("/api/master/agent", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterAgent = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getProvince: function() {
      var localApp = this;
      axios
        .get("/api/master/province", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterProvince = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getCompany: function() {
      var localApp = this;
      axios
        .get("/api/master/company", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterCompany = response.data.data.filter(
              (company) => !["RVP", "UD", "CPA"].includes(company.nickname)
            );
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    onSelectAgent: function(event) {
      this.selectedAgentIdx = event.target.value;
    },
    onSelectProvince: function(event) {
      this.selectedProvinceIdx = event.target.value;
    },
    onSelectCompany: function(event) {
      this.selectedCompanyIdx = event.target.value;
    },
    getStartDateInMonth() {
      let today = new Date();
      let firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      return firstDayOfMonth.getTime();
    },
    getEndDateInMonth() {
      let today = new Date();
      let lastDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
      return lastDayOfMonth.getTime();
    },
    advanceSearch: function(text) {
      var localApp = this;
      axios
        .get(
          "/api/insurance/search/history?page=" +
            localApp.page +
            "&text=" +
            text +
            "&startDate=" +
            this.start +
            "&endDate=" +
            this.to +
            "&agent=" +
            this.selectedAgentIdx +
            "&province=" +
            this.selectedProvinceIdx +
            "&company=" +
            this.selectedCompanyIdx,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:insurances", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          localApp.kick();
        });
    },
    loadInsuranceHistory: function() {
      var localApp = this;
      axios
        .get(
          "/api/insurance/history?page=" + localApp.page,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.$emit("update:insurances", response.data.data.data);
          localApp.$emit("update:total", response.data.data.total);
        })
        .catch(function() {
          localApp.kick();
        });
    },
    loadLatestPremium: function(id) {
      var localApp = this;
      axios
        .get("/api/insurance/latest_premium/" + id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          let data = response.data.data;
          if (data !== null) {
            localApp.sms.coverage = data.coverage;
            localApp.sms.insurance_premium = data.premium;
            localApp.sms.edit_reason = data.edit_reason;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    setPremiumAndCoverage: function(id) {
      var localApp = this;
      axios
        .patch("/api/insurance/set/" + id, localApp.sms, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.loadInsuranceHistory();
            // window.location.reload();
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    onEditPremium(id) {
      let localApp = this;
      localApp.showEditPremiumModal = false;
      localApp.setPremiumAndCoverage(id);
      // axios
      //   .patch(
      //     "/api/insurance/editpremium/" + id,
      //     localApp.sms,
      //     {
      //       headers: {
      //         Authorization: "Bearer " + localStorage.token,
      //       },
      //     }
      //   )
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       // window.location.reload();
      //     }
      //   })
      //   .catch(function(error) {
      //     alert(error);
      //   });
    },
    onExtend(id) {
      let routeData = this.$router.resolve({
        path: "/CustomerInsuranceExtend/" + id,
      });
      window.open(routeData.href, "_blank");
    },
    onExport() {
      this.export();
    },
    shout: function() {
      alert("สามารถแก้ไขเบี้ยได้ครั้งเดียวเท่านั้น");
    },
    export: function() {
      var localApp = this;
      let text = localApp.$parent.keyword;

      axios
        .get(
          "/api/insurance/export?startDate=" +
            this.start +
            "&endDate=" +
            this.to +
            "&text=" +
            text +
            "&agent=" +
            this.selectedAgentIdx +
            "&province=" +
            this.selectedProvinceIdx +
            "&company=" +
            this.selectedCompanyIdx,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          let insForExport = response.data.data;
          let jsonData = [];
          if (insForExport.length !== 0) {
            insForExport.forEach((item) => {
              let jsonObject = {};

              jsonObject["ตัวแทน"] = item.get_agent ? item.get_agent.name : "";
              jsonObject["เบอร์โทร"] = item.tel;
              jsonObject["ชื่อ-สกุล"] = item.name;
              jsonObject["บริษัท"] = item.company ? item.company.nickname : "";
              jsonObject["ทะเบียน"] = item.license_plate;
              jsonObject["วันหมดอายุ"] = localApp.formatDate(
                item.cover_end_date
              );
              jsonObject["ยี่ห้อ/รุ่น"] = item.get_brand
                ? item.get_brand.name
                : "";
              jsonObject["เลขตัวถัง"] = item.body_number;
              jsonObject["เลขกรมธรรม์"] = item.policy_number;
              jsonObject["วันหมดอายุพรบ."] = item.wsu_end
                ? localApp.formatDate(item.wsu_end)
                : "";
              jsonObject["เลขบัตรปชช."] = item.identity_no;

              jsonObject["ที่อยู่"] =
                item.address +
                " ต." +
                (item.getsub_district ? item.getsub_district.name : "") +
                " อ." +
                (item.getdistrict ? item.getdistrict.name : "") +
                " จ." +
                (item.getprovince ? item.getprovince.name : "");
              jsonObject["ทุนประกัน"] = item.coverage;
              jsonObject["เบี้ยประกัน"] = item.insurance_premium;
              jsonObject["ทุนประกัน (ใหม่)"] = item.new_coverage;
              jsonObject["เบี้ยประกัน (ใหม่)"] = item.new_insurance_premium;
              jsonObject["Note"] = item.edit_reason;
              jsonData.push(jsonObject);
            });
            const dataWS = XLSX.utils.json_to_sheet(jsonData);
            const wb = XLSX.utils.book_new();
            var wscols = [
              { wch: 10 },
              { wch: 10 },
              { wch: 20 },
              { wch: 8 },
              { wch: 7 },
              { wch: 15 },
              { wch: 10 },
              { wch: 20 },
              { wch: 20 },
              { wch: 15 },
              { wch: 14 },
              { wch: 30 },
              { wch: 10 },
              { wch: 10 },
              { wch: 15 },
              { wch: 15 },
              { wch: 20 },
            ];

            dataWS["!cols"] = wscols;
            XLSX.utils.book_append_sheet(wb, dataWS);
            XLSX.writeFile(wb, "export.xlsx");
          } else {
            alert("ไม่มีข้อมูลที่จะ Export");
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    toggleSelect(id) {
      if (this.selectedRow.includes(id)) {
        this.selectedRow.splice(
          this.selectedRow.findIndex((v) => v === id),
          1
        );
      } else {
        this.selectedRow.push(id);
      }
    },
    checkIfSelect(id) {
      return this.selectedRow.includes(id);
    },
    goTo(key) {
      let routeData = this.$router.resolve({
        path: "/customerInsuranceDetail/" + key,
      });
      window.open(routeData.href, "_blank");
    },
    selectAll() {
      let localApp = this;
      if (!localApp.isSelectAll) {
        localApp.insurances.forEach((element) =>
          this.selectedRow.push(element.id)
        );
        localApp.isSelectAll = true;
      } else {
        localApp.insurances.forEach((element) =>
          this.selectedRow.pop(element.id)
        );
        this.selectedRow.length = 0;
        localApp.isSelectAll = false;
      }
    },
    sendAllSms() {
      if (this.selectedRow.length <= 0) {
        alert("โปรดเลือกข้อมูลอย่างน้อย 1");
        return;
      }

      let localApp = this;
      localApp.showAllModal = false;
      axios
        .post(
          "/api/manysms2",
          {
            id: this.selectedRow,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            localApp.showSuccessModal = true;
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    sendAllPostcard() {
      if (this.selectedRow.length <= 0) {
        alert("โปรดเลือกข้อมูลอย่างน้อย 1");
        return;
      }

      window.open(
        "/api/insurance/getManyPostCard/" +
          this.selectedRow,
        "_blank"
      );
    },
    do: async function() {
      await this.getProvince();
      await this.getAgents();
      await this.getCompany();

      this.loadInsuranceHistory();
    },
  },
  watch: {
    page: function() {
      if (
        this.selectedAgentIdx === "" &&
        this.selectedProvinceIdx === "" &&
        this.selectedCompanyIdx === "" &&
        this.start === "" &&
        this.to === "" &&
        this.$parent.keyword === ""
      ) {
        this.loadInsuranceHistory();
      } else {
        this.advanceSearch(this.$parent.keyword);
      }
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.lvl = localStorage.level;
      this.do();
    }
  },
};
</script>
<style>
.tel {
  color: red;
}
.correct {
  vertical-align: middle;
}
.table td,
.btn-sm,
.text-sm {
  font-size: 1rem !important;
}
.table thead th,
.table th {
  font-size: 0.9rem !important;
}

.h3,
h3 {
  font-size: 1.2rem !important;
}

.cutname {
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date-picker .mx-input {
  cursor: pointer;
}
/* .company {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
</style>
